import { RefObject, useCallback, useEffect } from 'react';

/**
 * Hook that allows to detect click outside the element and call function passed as parameter
 * @param containerRefs refs of elements
 * @param onClickOutside: function to call on click outside
 * @param eventTarget: click event target
 */
export const useOnClickOutside = (
  containerRefs: RefObject<HTMLElement>[],
  onClickOutside: () => void,
  eventTarget: EventTarget = document
) => {
  const outsideClick = useCallback(
    (e: Event) => {
      const path = e.composedPath && e.composedPath();
      const isOutsideEvent = containerRefs
        .filter((container) => !!container)
        .every(({ current }) => current && !path?.includes(current));
      if (isOutsideEvent) onClickOutside();
    },
    [containerRefs, onClickOutside]
  );

  useEffect(() => {
    eventTarget?.addEventListener('click', outsideClick);
    return () => eventTarget?.removeEventListener('click', outsideClick);
  }, [containerRefs, eventTarget]);
};
